var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item mr-75 n-hide"},[_c('a',{staticClass:"nav-link",attrs:{"href":_vm.$routing('pannier')}},[_c('i',{staticClass:"ficon",staticStyle:{"color":"#FFFFFF"},attrs:{"data-feather":"shopping-cart"}}),_vm._v(" "),_c('span',{staticClass:"badge badge-pill badge-danger badge-up cart-item-count"},[_vm._v(_vm._s(_vm.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }